import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import OtpInput from 'react-otp-input'
import imgCard from 'static/img/card.svg'

const CustomClickToPayOtpInput = ({
  otpValue,
  onOtpChange,
  maskedEmail,
  maskedPhone,
  onResendCellphone,
  onResendEmail,
  onNotYouRequested,
  errorMessage,
  messageSentTo = `número ${maskedPhone}`,
}) => {
  const [remember, setRemember] = useState(false)

  useEffect(() => {
    localStorage.setItem('srcRememberMe', remember ? 'true' : 'false')
  }, [remember])

  return (
    <div>
      <div className="payment-logos">
        <div>
          <img src={imgCard} alt="logo" />
          <svg
            width="1"
            height="14"
            viewBox="0 0 1 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="0.834555"
              height="13.3529"
              rx="0.417277"
              fill="#141413"
            />
          </svg>
        </div>
        <img
          className="card-brand"
          src="https://src.mastercard.com/srci/integration/components/src-ui-kit/assets/mastercard.svg"
          alt="logo_mastercard"
        />
        <img
          className="card-brand"
          src="https://src.mastercard.com/srci/integration/components/src-ui-kit/assets/visa.svg"
          alt="logo_visa"
        />
      </div>

      <br />
      <div className="email-section">
        <span className="email-text">{maskedEmail}</span>
        <span
          className="not-you-link"
          onClick={onNotYouRequested}
          style={{ cursor: 'pointer' }}
        >
          Não é você?
        </span>
      </div>

      <div className="main-title">Acesse seus cartões Click to Pay</div>

      <div className="instruction-text">
        Insira o código que o Mastercard enviou para o {messageSentTo} para
        confirmar sua identidade.
      </div>

      <OtpInput
        id="custom_otp_input_otp_input"
        value={otpValue}
        onChange={onOtpChange}
        numInputs={6}
        renderSeparator=""
        renderInput={props => <input {...props} />}
        inputStyle={{
          width: '38px',
          height: '45px',
          margin: '0',
          marginRight: '8px',
          fontSize: '18px',
          fontWeight: '600',
          textAlign: 'center',
          border: errorMessage ? '1px solid #FF0000' : '1px solid #CCCCCC',
          borderRadius: '6px',
          backgroundColor: errorMessage ? '#FFF5F5' : '#FFFFFF',
          color: '#000000',
          outline: 'none',
          transition: 'all 0.2s ease',
        }}
        focusStyle={{
          borderColor: errorMessage ? '#FF0000' : '#CCCCCC',
          boxShadow: errorMessage
            ? '0 0 0 1px rgba(255, 0, 0, 0.1)'
            : '0 0 0 1px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#FFFFFF',
        }}
        containerStyle={{
          display: 'flex',
          justifyContent: 'left',
          margin: '0',
        }}
      />

      {/* Error message */}
      {errorMessage && (
        <div
          id="custom_otp_input_error_div"
          style={{
            color: '#FF0000',
            fontSize: '14px',
            marginTop: '8px',
            textAlign: 'left',
          }}
        >
          {errorMessage}
        </div>
      )}

      <div className="resend-section">
        <span className="resend-text">Reenviar código:</span>
        <div className="resend-links">
          <span onClick={onResendCellphone} className="resend-link">
            Celular
          </span>
          <span onClick={onResendEmail} className="resend-link">
            E-mail
          </span>
        </div>
      </div>
      <div className="remember-section">
        <input
          type="checkbox"
          className="remember-checkbox"
          checked={remember}
          onChange={e => setRemember(e.target.checked)}
        />
        <span className="remember-text">Lembrar de mim neste navegador</span>
        <div className="info-icon">i</div>
      </div>
    </div>
  )
}

CustomClickToPayOtpInput.propTypes = {
  otpValue: PropTypes.string.isRequired,
  onOtpChange: PropTypes.func.isRequired,
  maskedEmail: PropTypes.string.isRequired,
  maskedPhone: PropTypes.string.isRequired,
  onResendCellphone: PropTypes.func.isRequired,
  onResendEmail: PropTypes.func.isRequired,
  onNotYouRequested: PropTypes.func,
  errorMessage: PropTypes.string,
}

export default CustomClickToPayOtpInput
